module.exports = __webpack_public_path__ + "assets/img/schaakcomputer.c2afe76d.png";